<template>
    <ModalProcessoArtefato :showModal="showModalReal"
                           :flPermissao="flPermissaoUP"
                           :flProprietario="flProprietario"
                           :idProcessoModeloArtefato="idProcessoModeloArtefato?.toString()"
                           :idProcesso="idProcesso?.toString()"
                           :dsNome="dsNomeProcesso"
                           :nrOrdem="nrOrdem"
                           :idLegislacao="idLegislacao"
                           :cdLegislacao="cdLegislacao"
                           :flPrazo="flPrazoModal"
                           :dependencias="dependenciasModal"
                           :bloqueado="bloqueadoModal"
                           :etapaFluxo="etapaFluxoModal"
                           :temAlgumaEtapa="temAlgumaEtapaModal"
                           :flTemWorkflow="flTemWorkflow"
                           :dsLoginProprietario="dsLoginProprietarioProcesso"
                           @atualizar="onAtualizar"
                           @fechar="onFechar" />
</template>

<script>
    import axios from 'axios';
    import ModalProcessoArtefato from '@/components/ModalProcessoArtefato';
    import { urlApi, avisoErro, avisoToast } from '@/config/global';

    export default {
        name: 'ModalProcessoArtefatoGeral',
        components: { ModalProcessoArtefato },

        props: {
            showModal: { type: Boolean, default: false },
            item: {
                type: Object,
                required: false,
                default: () => null
            }
        },

        data() {
            return {
                flProprietarioData: false,
                lstPermissoesProcesso: [
                    { cdTipoPermissao: 'VS', flPermissao: false },
                    { cdTipoPermissao: 'UP', flPermissao: false },
                    { cdTipoPermissao: 'PE', flPermissao: false },
                    { cdTipoPermissao: 'IT', flPermissao: false }
                ],

                processoWorkflow: [],
                workflowConfig: [],
                dependenciasByCfgId: {},
                loadingDeps: false,
                lstProcessoArtefato: [],
                podeMostrarModal: false,
            };
        },

        computed: {
            user() {
                return this.$store.state.user;
            },
            isAdmContrato() {
                return this.$store.state.isAdmContrato;
            },
            isAdmin() {
                return this.$store.state.isAdmin === 'Sim';
            },
            podeGerenciarProcessos() {
                return this.isAdmContrato == 'Sim' || this.isAdmin;
            },

            idProcesso() {
                return this.item && this.item.idProcesso ? this.item.idProcesso : null;
            },
            idProcessoModeloArtefato() {
                return this.item && this.item.idProcessoModeloArtefato ? this.item.idProcessoModeloArtefato : null;
            },
            dsNomeProcesso() {
                return this.item?.dsNomeProcesso || '';
            },
            nrOrdem() {
                return this.item?.nrOrdem || null;
            },
            idLegislacao() {
                return this.item?.idLegislacao || null;
            },
            idTipoProcesso() {
                return this.item?.idTipoProcesso || null;
            },
            cdLegislacao() {
                return this.item?.cdLegislacao || null;
            },
            dsLoginProprietarioProcesso() {
                return this.item?.dsLoginProprietarioProcesso || null;
            },
            flTemWorkflow() {
                return !!this.item?.flWorkflow;
            },

            flProprietario() {
                return this.flProprietarioData;
            },
            flPermissaoUP() {
                return this.verificaPermissao('UP');
            },

            cfgSelecionada() {
                const list = Array.isArray(this.workflowConfig) ? this.workflowConfig : [];
                return (
                    list.find(
                        w =>
                            w.idProcessoModeloArtefato === Number(this.idProcessoModeloArtefato) ||
                            w.idModeloArtefato === Number(this.idProcessoModeloArtefato)
                    ) || null
                );
            },

            flPrazoModal() {
                return !!(this.cfgSelecionada && this.cfgSelecionada.flPrazo);
            },

            etapaFluxoModal() {
                const wf = this.cfgSelecionada;
                if (!wf) return null;

                if (wf.flRevisao) return 'revisao';
                if (wf.flAprovacao) return 'aprovacao';
                if (wf.flAssinatura) return 'assinatura';
                return null;
            },

            temAlgumaEtapaModal() {
                return this.etapaFluxoModal !== null;
            },

            dependenciasModal() {
                const pend = this.dependenciasPendentesNomesByModelId(this.idProcessoModeloArtefato);
                return pend.length ? pend : this.dependenciasNomesByModelId(this.idProcessoModeloArtefato);
            },

            bloqueadoModal() {
                return this.isBloqueado(this.idProcessoModeloArtefato);
            },
            showModalReal() {
                return this.showModal && this.podeMostrarModal;
            },
        },

        watch: {
            showModal(newVal) {
                if (newVal && this.item && this.idProcesso && this.idProcessoModeloArtefato) {
                    this.podeMostrarModal = false;
                    this.loadAll();
                } else if (!newVal) {
                    this.podeMostrarModal = false;
                }
            },
            item(newItem) {
                if (newItem && this.showModal && this.idProcesso && this.idProcessoModeloArtefato) {
                    this.podeMostrarModal = false;
                    this.loadAll();
                }
            }
        },

        mounted() {
            if (this.showModal && this.item && this.idProcesso && this.idProcessoModeloArtefato) {
                this.podeMostrarModal = false;
                this.loadAll();
            }
        },

        methods: {
            async loadAll() {
                if (!this.idProcesso) {
                    return;
                }

                try {
                    const temPermissao = await this.getPermissoesProcesso();
                    if (!temPermissao) {
                        return;
                    }
                    await Promise.all([
                        this.getProcessosWorkflow(),
                        this.getModelosProcesso()
                    ]);

                    this.podeMostrarModal = true;
                } catch (e) {
                    console.error('Erro ao fazer requisição!', e);
                }
            },

            onAtualizar() {
                this.$emit('atualizar');
                this.loadAll();
            },

            onFechar() {
                this.podeMostrarModal = false;
                this.$emit('fechar');
            },

            // ========== PERMISSÕES ==========
            async getPermissoesProcesso() {
                const idProcesso = this.idProcesso;
                if (!idProcesso) return false;

                const ownerLogin = this.dsLoginProprietarioProcesso;
                const meuLogin = this.user?.usuario?.dsLogin;

                this.lstPermissoesProcesso.forEach(p => {
                    p.flPermissao = false;
                });

                if (ownerLogin !== meuLogin) {
                    if (!this.podeGerenciarProcessos) {
                        this.flProprietarioData = false;

                        try {
                            const res = await axios.get(`${urlApi}/ProcessoPermissao/GetPermissoes/${idProcesso}`, {
                                showLoading: false,
                                params: { idProcesso }
                            });

                            if (res.data.success) {
                                const lstPermissao = res.data.data.lstPermissao || [];
                                const lstTipoPermissao = res.data.data.lstTipoPermissao || [];

                                for (let i = 0; i < this.lstPermissoesProcesso.length; i++) {
                                    const item = this.lstPermissoesProcesso[i];
                                    const tipoPermissao = lstTipoPermissao.find(
                                        x => x.cdTipoPermissao == item.cdTipoPermissao
                                    );

                                    if (tipoPermissao) {
                                        item.flPermissao = !!lstPermissao.find(
                                            x => x.idTipoPermissao == tipoPermissao.idTipoPermissao
                                        );
                                    } else {
                                        item.flPermissao = false;
                                    }
                                }
                            }
                        } catch (err) {
                            avisoErro(
                                err?.response?.data ||
                                err?.response?.statusText ||
                                'Erro ao carregar permissões do processo.'
                            );
                        }
                    } else {
                        this.flProprietarioData = true;
                        for (let i = 0; i < this.lstPermissoesProcesso.length; i++) {
                            this.lstPermissoesProcesso[i].flPermissao = true;
                        }
                    }
                } else {
                    this.flProprietarioData = true;
                    for (let i = 0; i < this.lstPermissoesProcesso.length; i++) {
                        this.lstPermissoesProcesso[i].flPermissao = true;
                    }
                }
                const temAlgumaPermissao =
                    this.flProprietarioData ||
                    this.lstPermissoesProcesso.some(p => p.flPermissao);

                if (!temAlgumaPermissao) {
                    avisoToast('Você não possui permissão para visualizar este artefato.', 'warning');
                    this.onFechar();
                }

                return temAlgumaPermissao;
            },


            verificaPermissao(cdTipoPermissao) {
                const permissao = this.lstPermissoesProcesso.find(x => x.cdTipoPermissao == cdTipoPermissao);
                return permissao ? !!permissao.flPermissao : false;
            },

            // ========== WORKFLOW / CONFIG ==========
            getProcessosWorkflow() {
                if (!this.idLegislacao || !this.idTipoProcesso) {
                    return Promise.resolve();
                }

                return axios
                    .get(`${urlApi}/ProcessoWorkflow/GetWorkflow`, {
                        params: {
                            idLegislacao: this.idLegislacao,
                            idTipoProcesso: this.idTipoProcesso
                        }
                    })
                    .then(res => {
                        if (res.data.success) {
                            const rows = res.data.data.rows || [];
                            this.processoWorkflow = rows
                                .map(r => r?.processoWorkflow || r)
                                .filter(Boolean);

                            const idProcessoWorkflow = this.processoWorkflow[0]?.idProcessoWorkflow;

                            if (!idProcessoWorkflow) {
                                this.workflowConfig = [];
                                return null;
                            }
                            return this.getWorkflowArtefatos(idProcessoWorkflow);
                        }
                    })
                    .catch(err => {
                        console.error('Erro ao carregar workflow:', err);
                        avisoToast('Erro ao carregar fluxo!', 'warning');
                    });
            },

            getWorkflowArtefatos(idProcessoWorkflow) {
                return axios
                    .get(`${urlApi}/ProcessoWorkflow/GetWorkflowArtefato`, {
                        params: { idProcessoWorkflow }
                    })
                    .then(res => {
                        const rows = res.data.data.rows || [];
                        if (!res.data.success || rows.length === 0) {
                            this.workflowConfig = [];
                            return [];
                        }
                        this.workflowConfig = rows.map(r => r?.processoWorkflowArtefato || r).filter(x => x && x.idProcessoWorkflowArtefato);

                        return this.fetchAllDependenciasIfNeeded();
                    })
                    .catch(err => {
                        this.workflowConfig = [];
                        avisoToast('Erro ao carregar configurações do fluxo!', 'warning');
                        throw err;
                    });
            },

            getWorkflowDependencia(idProcessoWorkflowArtefato) {
                return axios.get(`${urlApi}/ProcessoWorkflow/GetWorkflowDependencia`, {
                    params: { idProcessoWorkflowArtefato }
                });
            },

            async fetchAllDependenciasIfNeeded() {
                this.dependenciasByCfgId = {};
                if (!Array.isArray(this.workflowConfig) || this.workflowConfig.length === 0) return;

                this.loadingDeps = true;
                try {
                    const calls = this.workflowConfig
                        .filter(cfg => cfg?.idProcessoWorkflowArtefato && cfg.flDependencia === true)
                        .map(async cfg => {
                            try {
                                const res = await this.getWorkflowDependencia(cfg.idProcessoWorkflowArtefato);
                                const rows = res.data.data.rows || [];
                                this.$set(this.dependenciasByCfgId, cfg.idProcessoWorkflowArtefato, rows);
                            } catch {
                                this.$set(this.dependenciasByCfgId, cfg.idProcessoWorkflowArtefato, []);
                            }
                        });

                    await Promise.all(calls);
                } finally {
                    this.loadingDeps = false;
                }
            },

            // ========== ARTEFATOS DO PROCESSO ==========
            async getModelosProcesso() {
                if (!this.idProcesso) return;
                try {
                    const { data } = await axios.get(`${urlApi}/ProcessoArtefato/GetModelosProcesso`, {
                        params: { idProcesso: this.idProcesso },
                        showLoading: false
                    });

                    if (!data?.success) return;

                    const result = data.data || [];
                    const usaWorkflow = !!this.item?.flWorkflow;

                    this.lstProcessoArtefato = result.map(item => {
                        const flArtefatoFinalizado = usaWorkflow
                            ? item.nmStatusAtual === 'Finalizado'
                            : item.qtdEnviado > 0;

                        return {
                            idProcessoModeloArtefato: item.idProcessoModeloArtefato,
                            nmModelo: item.nmModelo,
                            flArtefatoFinalizado
                        };
                    });

                } catch (err) {
                    avisoErro(err?.response?.data || err.message || 'Erro ao carregar modelos do processo.');
                }
            },

            // ========== Helpers de dependência ==========
            cfgByModelId(modelId) {
                const list = Array.isArray(this.workflowConfig) ? this.workflowConfig : [];
                return (
                    list.find(
                        w =>
                            w.idProcessoModeloArtefato === Number(modelId) ||
                            w.idModeloArtefato === Number(modelId)
                    ) || null
                );
            },

            depModelIdsByModelId(modelId) {
                const cfg = this.cfgByModelId(modelId);
                if (!cfg) return [];

                const rows =
                    (this.dependenciasByCfgId || {})[cfg.idProcessoWorkflowArtefato] || [];

                const ids = rows
                    .map(r =>
                        r.processoWorkflowDependencia?.idProcessoModeloArtefatoDependencia ??
                        r.idProcessoModeloArtefatoDependencia ??
                        r.idModeloArtefatoDependencia ??
                        null
                    )
                    .filter(Boolean)
                    .map(Number);

                return [...new Set(ids)];
            },

            nomeByModelId(modelId) {
                const item = (this.lstProcessoArtefato || []).find(
                    i => i.idProcessoModeloArtefato === Number(modelId)
                );
                return item?.nmModelo ?? `Artefato ${modelId}`;
            },

            dependenciasNomesByModelId(modelId) {
                const ids = this.depModelIdsByModelId(modelId);
                const nomes = ids.map(id => this.nomeByModelId(id));
                return [...new Set(nomes)];
            },

            dependenciasPendentesNomesByModelId(modelId) {
                const ids = this.depModelIdsByModelId(modelId);
                const byId = new Map(
                    (this.lstProcessoArtefato || []).map(i => [i.idProcessoModeloArtefato, i])
                );
                return ids
                    .filter(id => !byId.get(id)?.flArtefatoFinalizado)
                    .map(id => this.nomeByModelId(id));
            },

            isBloqueado(modelId) {
                const pend = this.dependenciasPendentesNomesByModelId(modelId);
                return pend.length > 0;
            }
        },

    };
</script>
